package org.hs_soft.runmynesto.data.api_datasource.home

import org.hs_soft.runmynesto.data.local_datasource.local_storage.removeFromLocalStorage
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.DeleteCacheRepository
import org.hs_soft.runmynesto.domain.util.IdUtils


class DeleteCacheRepositoryImpl (): DeleteCacheRepository {
    override suspend fun deleteProductCache() {
        removeFromLocalStorage(IdUtils.productsDB)
        removeFromLocalStorage(IdUtils.defaultValues)
        removeFromLocalStorage(IdUtils.checkOutList)
    }


}

